export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "qr-code-styling.worker.9b18a5d4127829f1a411.js");
}
